export default {
    data: () => ({
        translations: {
            createTitle: {
                el: "Νέα Κατηγορία Προϊόντων",
                en: "New Product Category",
                it: "Nuova categoria di prodotti"
            },
            updateTitle: {
                el: "",
                en: "Update Product Category",
                it: ""
            },
            greekName: {
                el: "Όνομα στα Ελληνικά",
                en: "Name in Greek",
                it: "Nome in greco"
            },
            englishName: {
                el: "Όνομα στα Αγγλικά",
                en: "Name in English",
                it: "Nome in inglese"
            },
            italianName: {
                el: "Όνομα στα Ιταλικά",
                en: "Name in Italian",
                it: "Nome in italiano"
            },
            modalDesc: {
                el: "Αν δε βάλετε όνομα κατηγορίας στα αγγλικά ή στα ιταλικά, θα πάρει αυτόματα ελληνικό όνομα. ",
                en: "If you don't input english or italian name of category it will automatically take greek name ",
                it: "Se non inserisci il nome inglese o italiano della categoria, prenderà automaticamente il nome greco "
            },
        }
    })
};
